<template>
  <div class="app-container">
    <Menu v-if="isLoggedIn" />
    <div class="pages-container">
      <Loading v-if="isLoading"></Loading>
      <Confirm v-if="showConfirm"></Confirm>
      <Notification></Notification>
      <router-view />
    </div>
  </div>
</template>

<script>
import Confirm from '@/components/Confirm.vue';
import Loading from '@/components/Loading.vue';
import Menu from '@/components/Menu.vue';
import Notification from '@/components/Notification.vue';

export default {
  name: 'App',
  components: {
    Menu,
    Loading,
    Confirm,
    Notification,
  },
  mounted() {
    const bamboraScript = document.createElement('script');
    bamboraScript.setAttribute('src', process.env.VUE_APP_BAMBORA_JS);
    document.head.appendChild(bamboraScript);
    
    const bbmsScript = document.createElement('script');
    bbmsScript.setAttribute('src', process.env.VUE_APP_BBMS_JS);
    document.head.appendChild(bbmsScript);
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters['auth/isLoggedIn'];
    },
    isLoading: function () {
      return this.$store.getters['loading/isLoading'];
    },
    showConfirm() {
      return this.$store.getters['confirm/isDisplayed'];
    },
  },
};
</script>
